import Vue from 'vue';
import Vuex from 'vuex';

import tour from './modules/tour/tour';
import ui from './modules/ui';

import tours from './modules/tours';
import contact from './modules/contact';
import utils from './modules/utils';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    tour,
    ui,
    tours,
    contact,
    utils
  }
});
